import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=c89d218c&"
import script from "./Layout.vue?vue&type=script&lang=ts&"
export * from "./Layout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppBreadcrumbs: require('/home/vsts/work/1/a/NuxtApp/components/app/Breadcrumbs.vue').default,BlogSideMenu: require('/home/vsts/work/1/a/NuxtApp/components/blog/SideMenu.vue').default,BlogArticle: require('/home/vsts/work/1/a/NuxtApp/components/blog/Article.vue').default})
